import { allRoles, administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { accountPageActions } from "./accountPageActions";
import { accountPageConfig } from "./accountPageConfig";
import { accountPageBadges } from "./accountPageBadges";
import { accountRelatedTableActions } from "./accountRelatedTableActions";
import { adaptAccountRecord } from "./accountRecordAdapter";

export const accountRecordDefinition: RecordDefinition = {
  path: "/account",
  actions: accountPageActions,
  entityName: "account",
  listRoute: "/accounts",
  backTitle: "Back to accounts",
  allowedRoles: allRoles,
  recordEditRoles: administratorRoles,
  config: accountPageConfig,
  identity: {
    titleFields: ["name"],
    subtitleField: "emailaddress1",
    showAvatar: true,
    fallbackTitle: "Account",
    newRecordTitle: "New Account",
  },
  badges: accountPageBadges,
  recordAdapter: adaptAccountRecord,
  relatedTableActions: accountRelatedTableActions,
};
